import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const modeApi = api
  .enhanceEndpoints({ addTagTypes: ['Mode'] })
  .injectEndpoints({
    endpoints: builder => ({
      getModes: builder.query<bt_mmode[], string>({
        query: cid => `mode/${cid}`,
        providesTags: ['Mode']
      }),
      getMode: builder.query<bt_mmode, string>({
        query: id => `mode/byid/${id}`
      }),
      insertMode: builder.mutation({
        query: mode => ({
          url: `mode/`,
          method: 'POST',
          body: mode
        }),
        invalidatesTags: ['Mode']
      }),
      updateMode: builder.mutation({
        query: mode => ({
          url: `mode/`,
          method: 'PUT',
          body: mode
        }),
        invalidatesTags: ['Mode']
      }),
      deleteMode: builder.mutation({
        query: mode => ({
          url: `mode/${mode.md_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Mode']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetModesQuery,
  useGetModeQuery,
  useInsertModeMutation,
  useUpdateModeMutation,
  useDeleteModeMutation
} = modeApi;

